"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBookTitleCss = void 0;
const react_style_object_to_css_1 = __importDefault(require("react-style-object-to-css"));
const helpers_1 = require("../../helpers");
const getBookTitleCss = (themeProps, isPreviewer) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const styleProps = themeProps.properties;
    const titlePageConfigs = styleProps.bookTitlePage;
    const bookTitleFont = ((_a = titlePageConfigs === null || titlePageConfigs === void 0 ? void 0 : titlePageConfigs.title) === null || _a === void 0 ? void 0 : _a.fontMap)
        ? (0, helpers_1.getFontFamilyFromFontMap)(styleProps, titlePageConfigs.title.fontMap)
        : (0, helpers_1.getFontFamilyName)(styleProps.chapterTitle.font, (0, helpers_1.headerStyleToFontVariant)(styleProps.chapterTitle.style));
    const bookSubtitleFont = ((_b = titlePageConfigs === null || titlePageConfigs === void 0 ? void 0 : titlePageConfigs.subtitle) === null || _b === void 0 ? void 0 : _b.fontMap)
        ? (0, helpers_1.getFontFamilyFromFontMap)(styleProps, titlePageConfigs.subtitle.fontMap)
        : (0, helpers_1.getFontFamilyName)(styleProps.chapterTitle.font, (0, helpers_1.headerStyleToFontVariant)(styleProps.chapterTitle.style));
    const bookAuthorFont = ((_c = titlePageConfigs === null || titlePageConfigs === void 0 ? void 0 : titlePageConfigs.author) === null || _c === void 0 ? void 0 : _c.fontMap)
        ? (0, helpers_1.getFontFamilyFromFontMap)(styleProps, titlePageConfigs.author.fontMap)
        : (0, helpers_1.getFontFamilyName)(styleProps.chapterTitle.font, (0, helpers_1.headerStyleToFontVariant)(styleProps.chapterTitle.style));
    const bookPublisherFont = ((_d = titlePageConfigs === null || titlePageConfigs === void 0 ? void 0 : titlePageConfigs.publisher) === null || _d === void 0 ? void 0 : _d.fontMap)
        ? (0, helpers_1.getFontFamilyFromFontMap)(styleProps, titlePageConfigs.publisher.fontMap)
        : (0, helpers_1.getFontFamilyName)(styleProps.chapterNo.font, (0, helpers_1.headerStyleToFontVariant)(styleProps.chapterNo.style));
    return `
    .${themeProps._id} .title{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      height: ${isPreviewer ? "100%" : "100vh"};
    }
    
    .${themeProps._id} .title-card{
      position: relative;
      top:0px;
      width: 100%;
      text-align: center;
      padding: 2rem 0.4rem;
    }

    .${themeProps._id} .title-card h1{
      font-size: 44px;
      text-align: inherit;
      padding: 0.6em 0em;
      font-family: ${bookTitleFont};
      ${(0, react_style_object_to_css_1.default)((_f = (_e = styleProps.bookTitlePage) === null || _e === void 0 ? void 0 : _e.title) === null || _f === void 0 ? void 0 : _f.extras)}
    }
    
    .${themeProps._id} .title-card h2{
      font-size: 22px;
      text-align: inherit;
      padding: 1em 0em;
      font-weight: normal;
      font-family: ${bookAuthorFont};
      ${(0, react_style_object_to_css_1.default)((_h = (_g = styleProps.bookTitlePage) === null || _g === void 0 ? void 0 : _g.author) === null || _h === void 0 ? void 0 : _h.extras)}
    }
    
    .${themeProps._id} .title-card h3{
      font-size: 20px;
      text-align: inherit;
      padding: 1em 0em;
      font-family: ${bookSubtitleFont};
      ${(0, react_style_object_to_css_1.default)((_k = (_j = styleProps === null || styleProps === void 0 ? void 0 : styleProps.bookTitlePage) === null || _j === void 0 ? void 0 : _j.subtitle) === null || _k === void 0 ? void 0 : _k.extras)}
    }

    .${themeProps._id} .publisher-details{
      position: absolute;
      bottom: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 2rem 1.6rem;
      text-transform:capitalize;
      font-family: ${bookPublisherFont};
      ${(0, react_style_object_to_css_1.default)((_m = (_l = styleProps.bookTitlePage) === null || _l === void 0 ? void 0 : _l.publisher) === null || _m === void 0 ? void 0 : _m.extras)}
    }
    
    .${themeProps._id} .publisher-logo{
      width: auto;
      max-width: 80px !important;
      padding: 0.8rem 0rem;
    }

    .${themeProps._id} .publisher-logo img{
      width: 80px;
      height: auto;
    }
  `;
};
exports.getBookTitleCss = getBookTitleCss;
